// Generated by ts-to-zod
import { z } from 'zod';
import {
  integrationCredentialSecretSchema,
} from '../models/integrationCredential.schema';

export const testIntegrationCredentialPayloadSchema = z.object({
  type: z.string(),
  secret: integrationCredentialSecretSchema,
});
